<template>
  <div class="vf-text-center">
    <img
      :src="logoUrl"
      class="mx-auto block mb-4"
      style="height: 60px !important"
    />
    <h3 class="vf-text-2xl vf-mb-2">Welcome to Lenna.ai Platform!</h3>
    <p class="text-muted">
      Answer a few quick questions so we can set up the best experience tailored
      to your needs.
    </p>

    <base-button
      :theme="'secondary'"
      :customClass="`vf-w-[40%] vf-mt-6 vf-mx-auto vf-flex vf-items-center vf-gap-x-2 vf-justify-center`"
      type="button"
      @click="onContinue"
    >
      <span>Continue</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M15 16l4 -4" />
        <path d="M15 8l4 4" />
      </svg>
    </base-button>
  </div>
</template>

<script setup>
import { computed, defineEmits } from "vue";

const emitt = defineEmits(["onStateChange"]);

const urlTemp = computed(() => {
  let url = import.meta.env.VITE_APP_URL;
  if (window.location.hostname.split(".")[0] == "damcorp") {
    url = import.meta.env.VITE_DAMCORP_URL;
  } else if (window.location.hostname.split(".")[0] == "bawaslu") {
    url = import.meta.env.VITE_BAWASLU_URL;
  } else if (window.location.hostname.split(".")[0] == "pgd-omni") {
    url = import.meta.env.VITE_PEGADAIAN_URL;
  } else {
    url = import.meta.env.VITE_APP_URL;
  }
  return url;
});

const logoUrl = computed(() => `${urlTemp.value}/img/icons/favicon.svg`);

const onContinue = () => {
  window.localStorage.removeItem("_welcome");
  emitt("onStateChange", true);
};
</script>
